import React, { memo } from 'react';

const AnalyticsIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 24 24">
        <path
            d="M14.06 10.94L12 10L14.06 9.06L15 7L15.94 9.06L18 10L15.94 10.94L15 13L14.06 10.94ZM4 15L4.94 12.94L7 12L4.94 11.06L4 9L3.06 11.06L1 12L3.06 12.94L4 15ZM8.5 10L9.59 7.59L12 6.5L9.59 5.41L8.5 3L7.41 5.41L5 6.5L7.41 7.59L8.5 10ZM4.5 21.5L10.5 15.49L14.5 19.49L23 9.93L21.59 8.52L14.5 16.49L10.5 12.49L3 20L4.5 21.5Z"
            fill={color}
        />
    </svg>
);

export default memo(AnalyticsIcon);
